import login from "./login";
import { traderAutoLogin, weixinLogin } from "@/api/auth";
import { setToken } from "@/utils/auth";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      autoLogin: true
    };
  },
  created() {
    if (this.$route.query.authId && this.$route.query.authId.length > 20) {
      this.autoLogin = true;
      this.$vux.loading.show({
        text: "自动登录中"
      });
      setToken("");
      let traderLogin = traderAutoLogin({ username: this.$route.query.authId });
      let clientLogin = weixinLogin({ openId: this.$route.query.authId });
      Promise.all([traderLogin, clientLogin])
        .then(([traderRes, clientRes]) => {
          if (traderRes) {
            this.commonLogin({
              id: "",
              token: traderRes.access_token,
              type: 2
            }).then(() => {
              this.$router.replace("/salesman/index");
            });
          } else if (clientRes) {
            this.commonLogin(clientRes).then(() => {
              this.$router.replace("/");
            });
          } else {
            this.autoLogin = false;
          }
        })
        .catch(e => {
          this.autoLogin = false;
          this.$showError(e);
        })
        .finally(() => {
          this.$vux.loading.hide();
        });
    } else {
      this.autoLogin = false;
    }
  },
  methods: {
    ...mapActions(["choiceRole", "login", "GenerateRoutes", "commonLogin"])
  },
  render(h) {
    if (this.autoLogin) {
      return h("div", {});
    } else {
      return h(login);
    }
  }
};
